import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { toggleModal } from 'actions/appAction';

import { getCurrentLang } from 'helpers/utils';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

import { PromoText } from '../common/PromoText/PromoText';
import PromoLanguages from '../utils/PromoLanguages';

const FlexWrapper = styled.a`
    align-items: center;
    color: ${promoColors.gray80};
    display: inline-flex;

    &:hover {
        color: ${promoColors.gray40};

        svg path {
            stroke: ${promoColors.gray40};
        }
    }
`;
const LanguageLabel = styled.div`
    cursor: pointer;
    padding: 10px 0;
    margin-top: 32px;

    &:focus-visible {
        background-color: ${promoColors.gray20};
        border-radius: 2px;
        outline: 1px dashed ${promoColors.gray40};
    }

    ${promoMedia.tablet744} {
        display: inline-block;
        margin-top: 0;
        margin-left: 64px;
    }

    ${promoMedia.desktop1440} {
        margin-left: 80px;
    }
`;

const FooterLang = (props) => {
    const languages = props.noAuthFooter?.language?.languages;
    const lang = props.noAuthFooter?.language?.lang;
    const country = props.noAuthFooter?.language?.country;

    return (
        <LanguageLabel>
            <PromoText
                tag="div"
                data-testid="footer-lang-link-language"
                onClick={() =>
                    props.toggleModal(
                        true,
                        <PromoLanguages
                            lang={lang}
                            languages={languages}
                            title={props.siteLanguageTitle}
                            country={country}
                            isLanding={props.isLanding}
                            isRequest={props.isRequest}
                        />,
                    )
                }
                onKeyPress={() =>
                    props.toggleModal(
                        true,
                        <PromoLanguages
                            lang={lang}
                            languages={languages}
                            title={props.siteLanguageTitle}
                            country={country}
                            isLanding={props.isLanding}
                            isRequest={props.isRequest}
                        />,
                    )
                }
                tabIndex={'0'}
            >
                <FlexWrapper>
                    <span>{languages && Array.isArray(languages) ? getCurrentLang(languages, lang) : ''}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24">
                        <path d="m7 10 5 5 5-5" fill="none" stroke="#4e4e4e" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" />
                    </svg>
                </FlexWrapper>
            </PromoText>
        </LanguageLabel>
    );
};

FooterLang.propTypes = {
    lang: PropTypes.string,
    languages: PropTypes.arrayOf(
        PropTypes.shape({
            locale: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
    ),
};

const mapStateToProps = (state) => {
    return {
        siteLanguageTitle: state.extra.noAuthFooter?.language?.siteLanguageTitle,
        noAuthFooter: state.extra.noAuthFooter,
    };
};

export default connect(mapStateToProps, { toggleModal })(FooterLang);
